<script>
import baseList from "@/views/components/base/baseList.vue";
const customerId = window.localStorage.getItem("customerId");
import dayjs from "dayjs";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "accountingStatement",
        key: "id",
        url: {
          list: "/admin/system/sysFacilityMeterReading/accountingReport",
        },
        output: false,
        // order: "createTime",
      },
      query: {},
      actions: [
        {
          label: "打印",
          // icon: "md-add",
          onClick: this.onPrint,
          type: "info",
          auth: "",
        },
      ],
      menus: [
        {
          label: "抄张计费",
          name: "accounting_statement",
          auth: "",
        },
        {
          label: "抄张汇总",
          name: "copy_a_summary",
          auth: "",
        },
        {
          label: "纸张费率",
          name: "paperType_list",
          auth: "",
        },
      ],
      filters: [
        {
          label: "开始时间",
          KeyEnter: this.search,
          name: "dateTime",
          value: "",
          type: "datetimerangeYear",
        },
      ],
      tableCols: [],
      paperTypeList: [],
    };
  },
  created() {
    this.query.startDate = dayjs().startOf("year").format("YYYY-MM-DD");
    this.query.endDate = dayjs().endOf("year").format("YYYY-MM-DD");
    this.getPaperTypeList();
  },
  methods: {
    getPaperTypeList() {
      let q = {};
      $utils.api
        .load("/admin/system/paperType/options", q, "get")
        .then((res) => {
          console.log(res);
          this.paperTypeList = res.data;
          let tableCol = [
            {
              title: "序号",
              type: "index",
              width: 80,
              align: "center",
            },
            {
              title: "收费区间",
              key: "chargePeriod",
              minWidth: 120,
              align: "left",
            },
            {
              title: "核算科室",
              key: "checkDeskName",
              minWidth: 150,
              align: "center",
              tooltip: "true",
            },
            {
              title: "设备型号",
              minWidth: 150,
              align: "center",
              key: "facilityModel",
              tooltip: "true",
            },
          ];
          this.paperTypeList.forEach((item) => {
            let obj = {
              title: item.typeName + `（${item.rate}元）`,
              width: 160,
              align: "center",
              tooltip: "true",
              render: (h, params) => {
                const row = params.row;
                return row.readingDetails.map((items) => {
                  if (items.typeName == item.typeName) {
                    return <div>{items.amount}</div>;
                  }
                });
              },
            };

            tableCol.push(obj);
          });
          tableCol.push({
            title: "本期合计（元）",
            width: 140,
            align: "center",
            key: "totalAmount",
            tooltip: "true",
          });
          this.tableCols = tableCol;
        });
    },

    onPrint() {
      //   let q = this.query;
      //   let customerNameStr =
      //     Number(customerId) === 0
      //       ? window.localStorage.getItem("customerNameClick")
      //       : window.localStorage.getItem("customerName");
      let q = this.query;
      let customerNameStr = window.localStorage.getItem("customerName");
      $utils.api
        .load(
          "/admin/system/sysFacilityMeterReading/accountingReport",
          q,
          "get"
        )
        .then((res) => {
          let list = [];
          res.rows.forEach((item, index) => {
            console.log(item);
            let obj = {
              index: index + 1,
              chargePeriod: item.chargePeriod,
              checkDeskName: item.checkDeskName,
              facilityModel: item.facilityModel,
            };
            item.readingDetails.forEach((items) => {
              obj[items.typeName] = items.amount;
            });
            obj.totalAmount = item.totalAmount;
            list.push(obj);
          });
          console.log(list);

          let properties = [
            { field: "index", displayName: "序号" },
            { field: "chargePeriod", displayName: "收费区间" },
            { field: "checkDeskName", displayName: "核算科室" },
            { field: "facilityModel", displayName: "设备型号" },
          ];

          this.paperTypeList.forEach((item) => {
            let obj2 = {
              field: item.typeName,
              displayName: item.typeName + `（${item.rate}元）`,
            };
            properties.push(obj2);
          });
          properties.push({
            field: "totalAmount",
            displayName: "本期合计（元）",
          });
          printJS({
            printable: list,
            properties: properties,
            header: customerNameStr + "抄张计费核算表",
            headerStyle: `
                      font-weight:800;
                      font-size:18px;
                      text-align: center;
                      `,
            gridHeaderStyle: "border:none;",
            gridStyle: "border:none",
            style: `
                          th{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          }
                          td{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          text-align:center;
                          }
                          `,
            type: "json",
          });
        });
    },
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "edit_rate", query: { action: "add" } });
    },
    toinfo(row) {
      $utils.url.push({
        name: "edit_rate",
        query: {
          action: "edit",
          kv: row.id,
          facilityTypeId: row.facilityTypeId,
        },
      });
    },
  },
};
</script>
<style scoped></style>
